/**
 * Framework/domain-agnostic catalog node for the export-template column picker.
 * Each feature adapts its own API catalog (virtual-clinic `ExportProperty`,
 * clinics-filter `QbExportColumnNode`, …) into this shape and feeds it to
 * {@link BdExportTemplateFormComponent}. `selectable` marks a pickable leaf
 * column (as opposed to a grouping node).
 */
export interface BdExportColumnOption {
  id: string;
  displayName: string;
  selectable: boolean;
  children: BdExportColumnOption[];
}

export class BdExportColumnOptions {
  /** Depth-first lookup of an option by id. */
  public static findById(
    options: BdExportColumnOption[],
    id: string,
  ): BdExportColumnOption | null {
    for (const option of options) {
      if (option.id === id) {
        return option;
      }
      const found = BdExportColumnOptions.findById(option.children ?? [], id);
      if (found) {
        return found;
      }
    }
    return null;
  }

  /** Returns the parent option whose children contain the given id. */
  public static findParentById(
    options: BdExportColumnOption[],
    id: string,
    parent: BdExportColumnOption | null = null,
  ): BdExportColumnOption | null {
    for (const option of options) {
      if (option.id === id) {
        return parent;
      }
      const found = BdExportColumnOptions.findParentById(
        option.children ?? [],
        id,
        option,
      );
      if (found) {
        return found;
      }
    }
    return null;
  }
}
